/* QOWAA FIT — Page COMMUNAUTÉ : reveal au scroll (IntersectionObserver sur .scroll-in).
   Le .is-in déclenche aussi le fade séquentiel des cartes incentive (.avis.is-in .incentive-card). */
(function () {
  'use strict';
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  // Compteur communauté : count-up animé quand le nombre entre dans le viewport.
  function countUp(el) {
    if (el.dataset.qwCounted) return;
    el.dataset.qwCounted = '1';
    var raw = el.textContent.trim();
    var m = raw.match(/^(\D*?)([\d\s]+)(\D*)$/);
    if (!m) return;
    var prefix = m[1] || '', suffix = m[3] || '';
    var target = parseInt(m[2].replace(/[^\d]/g, ''), 10);
    if (!target || target < 100) return;
    function fmt(n) { return prefix + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + suffix; }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !window.requestAnimationFrame) { el.textContent = fmt(target); return; }
    var dur = 1500, start = null;
    el.textContent = fmt(0);
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1), eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(eased * target));
      if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }

  function initCounter(root) {
    var el = root.querySelector('.hero-com__counter');
    if (!el) return;
    if (!('IntersectionObserver' in window)) { countUp(el); return; }
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { countUp(en.target); co.unobserve(en.target); } });
    }, { threshold: 0.4 });
    co.observe(el);
  }

  function initCommunity(root) {
    initCounter(root);
    var els = $all('.scroll-in', root);
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  function boot() { $all('[data-qw-community]').forEach(initCommunity); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-qw-community]'); if (r) initCommunity(r); });
})();
